import styled from 'styled-components'
import { Popover, Button } from 'react-bootstrap'

export const StyledPopover = styled(Popover)`
  max-width: 650px;
  min-width: 600px;
  width: 60%;
`

export const PopoverHeader = styled.div`
  background: ${({ theme }) => theme.colors?.primary || '#173b68'};
  color: white;
  font-weight: 600;
  padding: 1rem 1.5rem;
  position: relative;

  h3 {
    margin: 0;
    color: white;
    font-weight: 600;
    font-size: 2rem;
    margin-bottom: 0;
  }
`

export const PopoverBody = styled.div`
  padding: 2rem;
  background-color: white;

  label,
  .form-label {
    font-weight: 600;
    padding-top: 1rem;
    padding-right: 0.5rem;
  }

  .required-field:after {
    content: '*';
    color: ${({ theme }) => theme.colors?.issueColor || '#b11926'};
    margin-left: 0.2rem;
  }
`

export const CloseButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  padding: 0;
  width: 30px;
  height: 30px;
`

export const FormSection = styled.div`
  .form-control {
    border-radius: 0.25rem !important;
    height: calc(1.5em + 0.75rem + 0.2rem);
    padding: 0.375rem 0.75rem;

    &:focus {
      background-color: #fff;
      border-color: ${({ theme }) => theme.colors?.inputBorder || '#173b68'};
      outline: 0;
    }
  }

  .error-message {
    color: ${({ theme }) => theme.colors?.issueColor || '#b11926'};
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  .form-group {
    width: 100%;
    margin-bottom: 1rem;
  }
`

export const ButtonGroup = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export const SaveButton = styled(Button)`
  /* Basic button styling, relies on Bootstrap primary variant */
`

export const CancelButton = styled(Button)`
  /* Basic button styling, relies on Bootstrap light variant */
`

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 0.875rem;

  &::after {
    content: '';
    width: 20px;
    height: 20px;
    margin-left: 0.5rem;
    border: 2px solid #e5e7eb;
    border-top: 2px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
